export interface TableSelectedItem {
  title: string;
  url: string[];
}

export interface FilterField<TValue, TOperator = string> {
  operator: TOperator;
  value: TValue;
}

export interface ColumnFilterSortConfig<TOperator = string> {
  filtering?: readonly TOperator[];
  sorting?: boolean;
}

/** The operator a caller should default to for a filterable column - its `filtering` list's first entry. */
export function defaultColumnOperator<TKey extends string, TOperator>(
  columns: Record<TKey, ColumnFilterSortConfig<TOperator>>,
  key: TKey,
): TOperator {
  const operator = columns[key].filtering?.[0];

  if (operator === undefined) {
    throw new Error(`Column "${key}" does not support filtering`);
  }

  return operator;
}

export interface SavedTableSettings {
  columns: string[];
  filters: {
    [key: string]: string | string[];
  };
  lastSelectedItems: TableSelectedItem[];
  zoomSize: number;
}

export const DefaultSavedTableSettings: SavedTableSettings = {
  columns: [],
  filters: {},
  lastSelectedItems: [],
  zoomSize: 100,
};

export function cloneDefaultTableSettings() {
  return JSON.parse(JSON.stringify(DefaultSavedTableSettings));
}
